import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

import "react-toastify/dist/ReactToastify.css";
import TablePagination from "../../../components/TablePagination";
import UserLogin from "../../../models/UserLogin";
import api from "../../../services/api";
import { authenticationService } from "../../../services/auth.service";

import "./presence-list.css";

interface Params {
  idEvent?: number;
}

interface PresenceRow {
  id?: number;
  title?: string;
  qtyPeople?: number;
}

export default function PresenceList(props: Params) {
  const [refresh, setRefresh] = useState<boolean>();
  const navigate = useNavigate();
  const {idEvent} = props;
  
  const columns = [
    {
      name: "Lista",
      sortable: true,
      grow: 3,
      cell: (row: PresenceRow) => (
        <div className="uk-flex uk-flex-column uk-margin-xsmall-y">
          <span className="uk-text-bold">{row.title || "-"}</span>
          <span className="uk-text-small uk-text-muted">
            {row.qtyPeople ?? 0} pessoa(s)
          </span>
        </div>
      )
    },
    {
      name: "Pessoas",
      button: true,
      sortable: false,
      cell: (row: PresenceRow) => (
        <button
          type="button"
          onClick={(ev) => {
            ev.preventDefault();

            if (!idEvent || !row?.id) {
              return;
            }

            navigate(`/eventos/${idEvent}/presencas/${row.id}/pessoas`, {
              state: {
                presenceTitle: row.title
              }
            });
          }}
          className="uk-button uk-button-link uk-padding-remove"
          uk-tooltip="title: Ver pessoas da lista"
        >
          <FontAwesomeIcon icon={faUsers} />
        </button>
      )
    }
  ];

  useEffect(() => {}, [idEvent]);

  const fetchPresenceList = async (page: number, limit: number) => {
    try {
      const response = await api.get(`/events/${idEvent}/presence/list`, {
        params: {
          page: page,
          limit: limit,
          user: authenticationService.isAuxSec()
            ? (authenticationService.currentUserValue as UserLogin).id
            : null,
        },
      });

      return response;
    } catch {
      return { data: [], total: 0 };
    }
  };

  return (
    <div id="page-presence-list">
      <div
        className="uk-card uk-card-default uk-card-small uk-card-hover uk-margin-bottom"
      >
        <div className="uk-card-header">
          <div className="uk-grid-small uk-flex-middle" uk-grid="true">
            <div className="uk-width-expand">
              <h3 className="uk-card-title uk-margin-remove-bottom">
                Listas de Presença
              </h3>
            </div>
          </div>
        </div>
        <div className="uk-card-body">
          {
            props.idEvent &&
              <TablePagination
                columns={columns}
                fetchData={fetchPresenceList}
                refresh={refresh}
                messageEmpty={<span>Nenhuma <b>lista</b> encontrada!</span>}
              />
          }
        </div>
      </div>
    </div>
  );
}
